import { render, staticRenderFns } from "./Identifier.vue?vue&type=template&id=a92be2c8&scoped=true&lang=pug&"
import script from "./Identifier.vue?vue&type=script&lang=js&"
export * from "./Identifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92be2c8",
  null
  
)

export default component.exports